<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3>
          <i class="fas fa-chart-line"></i> Relatórios Acessos
        </h3>
      </div>
    </div>
    <Tables
      ref="tableGrid"
      :columns="columns"
      :showSearch="false"
      :showReload="false"
      :showTipFooter="false"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <template>
          <TableColumn
            v-on:Edit="openCard(obj.cardId)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.user.nomePessoa || obj.user.userFila ? obj.user.nomePessoa : obj.user.userFila"
          />
          <TableColumn
            v-on:Edit="openCard(obj.cardId)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.ipAddress || '-'"
          />
          <TableColumn
            v-on:Edit="openCard(obj.cardId)"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="formatDateAndTime(obj.startTime) || '-'"
          />

        </template>
      </tr>
    </Tables>
    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      :boardColumns="[]"
      @hideModal="closeCard"
      :key="selectedCard"
      :cardId="selectedCard"
      @reloadBoardColumns="reloadGrid"
    />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ReportAcessoRepository from '@/shared/http/repositories/reports/reportAcessos'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import {
  NxDataGrid,
  NxDataGridColumn,
  NxDataGridItem
} from '@/components/nexum/components'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import SidebarSearch from '@/views/private/reports/followup/crmActions/search/SidebarRelatorioCrmActions.vue'

export default {
  name: 'ReportAcessos',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      columns: [],
      columnsOpt: [
        'NOME USUARIO',
        'IP',
        'DATA/HORA DO LOGIN'
      ],
      selectedCard: null
    }
  },
  components: {
    AddConfirmation,
    NxDataGrid,
    NxDataGridColumn,
    NxDataGridItem,
    SidebarSearch,
    ModalCard
  },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onLoad () {
      this.setColumns()
      if (this.filters) {
        this.onLoadAll()
      } else {
        this.onLoadAll()
      }
    },
    load (params) {
      return ReportAcessoRepository.GetAllReportAcessos(this.filters, {
        params
      })
    },
    onLoadAll () {
      loading.push()
      ReportAcessoRepository.GetAllReportAcessos(
        this.$refs.tableGrid.pagingLimit,
        this.$refs.tableGrid.pagingIndex
      )
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
        .finally(() => {
          loading.pop()
        })
    },
    showConfirmationModal () {
      this.$refs['confirmation-modal'].showModal()
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    setColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        this.columns.push(this.columnsOpt[i])
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    reloadGrid () {
      this.onLoad()
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    },
    onLimitCarac (text) {
      return text.length > 100 ? text.substring(0, 100).concat('...') : text
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/relatorioAcesso/relatorioAcesso.vue